import { Flex, Image } from '@chakra-ui/react';

export const SupportedCreditVariationList = () => {
  const icon_dimenter = 6;
  const icons = [
    '/assets/credit/Amex_logo.svg',
    '/assets/credit/Visa_Inc._logo.svg',
    '/assets/credit/Mastercard-logo.svg',
    '/assets/credit/JCB_logo.svg',
    '/assets/credit/diners_logo_white.png',
  ];
  return (
    <Flex flexDir="row" gridGap={2}>
      {icons.map((icon, index) => {
        return <Image key={index} src={icon} w="auto" h={icon_dimenter} />;
      })}
    </Flex>
  );
};
